import { Popconfirm } from "antd";
import styled from "styled-components";

export const StyledPopconfirm = styled(Popconfirm)`
  color: var(--main-color);
  .ant-popover-inner-content,
  .ant-popover-arrow-content::before {
    background: #333336;
  }
  .ant-popover-inner-content {
    padding: 16px;
  }
  .ant-popover-message-icon {
    margin-right: 0;
  }
  .ant-popover-message {
    padding-bottom: 24px;
  }
  .ant-popover-buttons {
    button:nth-child(1) {
      color: var(--main-color);
      background: transparent;
      border: 0;
    }
  }
`;
